export const server = {
    "serverUrl": "https://web.altosdeazpitia.com/",
    "publicKeyIziPay":"79296642:publickey_JKcpzseJe6Staaell9dyKkDtbtNAiJ28mdqYD7GGXwj37"
}